import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const ACTION_META = {
  paper_buy:              { label: 'Paper Buy',         color: '#9ef7c5', bg: 'rgba(158,247,197,0.14)' },
  accumulate_signal:      { label: 'Accumulate',        color: '#9ef7c5', bg: 'rgba(158,247,197,0.14)' },
  watch:                  { label: 'Watch',             color: '#ffe55c', bg: 'rgba(255,229,92,0.14)'  },
  reduce_exposure_signal: { label: 'Reduce Exposure',   color: '#ff9a3c', bg: 'rgba(255,154,60,0.14)'  },
  avoid:                  { label: 'Avoid',             color: '#ff4d6a', bg: 'rgba(255,77,106,0.14)'  },
  confirm_risk:           { label: 'Confirm Risk',      color: '#ff4d6a', bg: 'rgba(255,77,106,0.14)'  },
  investigate:            { label: 'Investigate',       color: '#a78bfa', bg: 'rgba(167,139,250,0.14)' },
  request_more_evidence:  { label: 'More Evidence',     color: '#9ea4d8', bg: 'rgba(158,164,216,0.12)' },
  paper_hold:             { label: 'Paper Hold',        color: '#cfd8ff', bg: 'rgba(207,216,255,0.12)' },
};

const useStyles = makeStyles(() => ({
  chip: {
    height: 20,
    fontSize: 10,
    fontWeight: 900,
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    border: '1px solid',
  },
}));

export default function ActionBadge({ actionType, size = 'small', style = {} }) {
  const classes = useStyles();
  const meta = ACTION_META[actionType] || { label: String(actionType || '—'), color: '#9ea4d8', bg: 'rgba(158,164,216,0.12)' };
  return (
    <Tooltip title={`Action: ${meta.label}`} placement="top">
      <Chip
        size={size}
        label={meta.label}
        className={classes.chip}
        style={{
          color: meta.color,
          backgroundColor: meta.bg,
          borderColor: meta.color,
          opacity: 0.9,
          ...style,
        }}
      />
    </Tooltip>
  );
}
